import { useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { dayLabel } from "@/lib/dates";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const OfferDialog = ({ slot, members, me, onClose, onSaved }) => {
  const [mode, setMode] = useState("anyone");
  const [to, setTo] = useState("");
  const [note, setNote] = useState("");
  const others = members.filter((m) => m.id !== me.id && m.can_sign && (!m.areas?.length || m.areas.includes(slot.area_id)) && (!m.positions?.length || m.positions.includes(slot.position)));
  const save = async () => {
    try {
      await api.post(`/rota/slots/${slot.id}/offer`, { to_user_id: mode === "member" ? to : null, note });
      toast.success(mode === "member" ? "Shift offered" : "Shift is now up for swap");
      onSaved();
      onClose();
    } catch (e) { toast.error(errMsg(e)); }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="offer-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl">Give away shift</DialogTitle></DialogHeader>
        <p className="text-sm text-muted-foreground">{slot.area_name} · {dayLabel(slot.date)} · {slot.template_name} {slot.start}–{slot.end} · {slot.position_label}</p>
        {slot.vehicle_name && <p className="rounded-lg bg-secondary px-3 py-2 text-xs">Your booking of <b>{slot.vehicle_name}</b> moves with the shift if it is still on road and approved for the new member.</p>}
        <div className="grid grid-cols-2 gap-2">
          {[["anyone", "Anyone"], ["member", "One member"]].map(([k, l]) => (
            <button key={k} onClick={() => setMode(k)} data-testid={`offer-mode-${k}`} className={`rounded-full border-2 py-2 text-sm font-semibold ${mode === k ? "border-primary bg-primary text-primary-foreground" : "text-muted-foreground"}`}>{l}</button>
          ))}
        </div>
        {mode === "member" && (
          <div className="space-y-1.5"><Label>Offer to</Label>
            <Select value={to || undefined} onValueChange={setTo}><SelectTrigger data-testid="offer-member-select"><SelectValue placeholder="Select member" /></SelectTrigger>
              <SelectContent>{others.map((m) => <SelectItem key={m.id} value={m.id}>{m.name}</SelectItem>)}</SelectContent></Select>
          </div>
        )}
        <div className="space-y-1.5"><Label>Note (optional)</Label>
          <input value={note} onChange={(e) => setNote(e.target.value)} data-testid="offer-note-input" className="w-full rounded-lg border bg-background px-3 py-2 text-sm" placeholder="e.g. family commitment" />
        </div>
        <button disabled={mode === "member" && !to} onClick={save} data-testid="offer-save-btn" className="w-full rounded-full bg-primary py-3 text-sm font-bold text-primary-foreground disabled:opacity-40">Offer shift</button>
      </DialogContent>
    </Dialog>
  );
};
